import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EvadocInfoDto } from '../dto/evadoc-info-dto';
import { Observable, throwError } from 'rxjs';
import { RespuestaDto } from '../dto/respuesta-dto';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EvadocDocenteService {

  url = `${environment.host}/api/evadoc-docentes`;

  constructor(
    private http: HttpClient
  ) { }

  public GuardarDocentes(evadocDocentes: EvadocInfoDto[]): Observable<RespuestaDto> {
    return this.http.post<RespuestaDto>(`${this.url}/insertarDocente`, evadocDocentes).pipe(catchError(error => {
      console.log('Error service Evadoc docente-guardar', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }

  obtenerDocentesUaa(uaa: number): Observable<EvadocInfoDto[]> {
    return this.http.get<EvadocInfoDto[]>(`${this.url}/listar/${uaa}`);
  }
}
